import axios from './interceptor';

const INQRY_URL = `${process.env.REACT_APP_BASE_URL}/inquiry`;

export async function getAllInquiries(page, size, search = "", leadSource = "", startDate = "", endDate = "", createdStartDate = "", createdEndDate = "", assignedUser = "") {
    const ADDUSER_URL = `${INQRY_URL}/get-all-inquiries`;
    
    // Build params object only with truthy/non-empty values
    const requestedParams = {
        page,
        size,
        search,
        leadSource,
        startDate,
        endDate,
        createdStartDate,
        createdEndDate,
        assignedUser
    };

    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(requestedParams)) {
        if (value !== "" && value !== null && value !== undefined) {
            params.append(key, value);
        }
    }

    const response = await axios.get(`${ADDUSER_URL}?${params.toString()}`);
    return response.data;
}

export async function getInquiryStats(search = "", leadSource = "", startDate = "", endDate = "", createdStartDate = "", createdEndDate = "") {
    const URL = `${INQRY_URL}/get-stats`;
    const requestedParams = { search, leadSource, startDate, endDate, createdStartDate, createdEndDate };
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(requestedParams)) {
        if (value) params.append(key, value);
    }
    const response = await axios.get(`${URL}?${params.toString()}`);
    return response.data;
}

// delete inquiry
export async function deleteInquiry(id) {
    const DELETE_URL = `${INQRY_URL}/delete-inquiry/${id}`;
    const result = await axios.delete(DELETE_URL);
    return result.data;
}

export async function InquiryUserAssign(payload) {
    const ADDUSER_URL = `${INQRY_URL}/user-assign`;
    const result = await axios.post(ADDUSER_URL, payload);
    return result.data;
}

export async function InquiryUserRemove(payload) {
    const ADDUSER_URL = `${INQRY_URL}/user-remove`;
    const result = await axios.post(ADDUSER_URL, payload);
    return result.data;
}

export async function addRemark(inquiryId, text) {
    const REMARK_URL = `${INQRY_URL}/${inquiryId}/remark`;
    const result = await axios.post(REMARK_URL, { text });
    return result.data;
}

export async function addReplyToRemark(inquiryId, remarkId, text) {
    const REPLY_URL = `${INQRY_URL}/${inquiryId}/remark/${remarkId}/reply`;
    const result = await axios.post(REPLY_URL, { text });
    return result.data;
}

export async function checkDuplicateInquiries(email, phone, excludeId, destination = "") {
    const URL = `${INQRY_URL}/check-duplicates`;
    const result = await axios.post(URL, { email, phone, excludeId, destination });
    return result.data;
}

export async function updateInquiry(id, updates) {
    const URL = `${INQRY_URL}/update/${id}`;
    const result = await axios.put(URL, updates);
    return result.data;
}

export async function createInquiry(payload) {
    const URL = `${INQRY_URL}/create-inquiry`;
    const result = await axios.post(URL, payload);
    return result.data;
}

// ─── Call Test APIs ───────────────────────────────────────────────────────────
export async function getAllCallTest(page, size, search = "", leadSource = "", startDate = "", endDate = "", createdStartDate = "", createdEndDate = "", assignedUser = "") {
    const URL = `${INQRY_URL}/get-all-calltest`;
    const requestedParams = { page, size, search, leadSource, startDate, endDate, createdStartDate, createdEndDate, assignedUser };

    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(requestedParams)) {
        if (value !== "" && value !== null && value !== undefined) {
            params.append(key, value);
        }
    }

    const response = await axios.get(`${URL}?${params.toString()}`);
    return response.data;
}

export async function createCallTest(payload) {
    const URL = `${INQRY_URL}/create-CallTest`;
    const result = await axios.post(URL, payload);
    return result.data;
}

export async function updateCallTest(id, updates) {
    const URL = `${INQRY_URL}/updateCallTest/${id}`;
    const result = await axios.put(URL, updates);
    return result.data;
}
